import type { GetAnonymousCustomersReportResponse } from '@weft/api-definition';
import { GetAnonymousCustomersReportResponseSchema } from '@weft/api-definition';
import { validateNotNullOrUndefined, withDefault } from '@weft/utils';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useAnonymousCustomersReport(reportId?: string, options?: UseQueryOptions<GetAnonymousCustomersReportResponse>) {
  const getAnonymousCustomersQuery = useQuery({
    queryKey: ['reports', 'anonymous-customers-report', withDefault(reportId, '')],
    queryFn: async () => {
      const privateApi = getPrivateApi();

      const getAnonymousCustomersDataResponse = await privateApi.getAnonymousCustomersReport({ reportId });

      return GetAnonymousCustomersReportResponseSchema.parse(getAnonymousCustomersDataResponse);
    },
    suspense: true,
    ...options,
  });

  validateNotNullOrUndefined(getAnonymousCustomersQuery.data, 'getAnonymousCustomersQuery data');

  return getAnonymousCustomersQuery;
}